<template>
    <!--<img src="../../assets/guanyin.jpg" class="portrait_guanyin"/>-->
    <div style="" class="portrait_guanyin_box">
        <div class="portrait_guanyin_ring2"></div>
        <div class="portrait_guanyin"></div>
    </div>
</template>

<script>
    import { reactive, toRefs, computed } from 'vue'

    export default {
        name: 'GuanyinPortrait',
        props: {},
        setup: (props, context) => {
            const state = reactive({
                props,
            })

            return {
                ...toRefs(state),
            }
        }
    }
</script>

<style scoped lang="scss">
    .portrait_guanyin_box {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .portrait_guanyin {
        position: absolute;
        width: 98%;
        height: 98%;
        border-radius: 100%;
        background-image: url("~@/assets/guanyin.png"),
        radial-gradient(at 50% 60%,transparent 50%, #ccc);
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;

        animation-name: anima2;
        animation-duration: 0.5s;
        animation-direction: alternate;
        animation-iteration-count: infinite;
    }

    @keyframes anima2 {
        100% {
            opacity: 80%;
        }
    }

    .portrait_guanyin_ring {
        position: absolute;
        width: 30%;
        height: 30%;
        border: 1px solid black;
        border-radius: 50%;

        animation-name: animation1;
        animation-duration: .5s;
        /*animation-timing-function: linear;*/
        animation-direction: alternate;
        animation-iteration-count: infinite;
    }

    @keyframes animation1 {
        0% {
            width: 30%;
            height: 30%;
            top: 2%;
        }

        100% {
            width: 32%;
            height: 32%;
            top: 1%;
            opacity: 40%;
        }
    }

    .portrait_guanyin_ring2 {
        position: absolute;
        width: 30%;
        height: 30%;
        border-radius: 50%;
        top: 2%;

        background: repeating-conic-gradient(#000 -.5% .5%, transparent .5% calc(1 / 12 * 100% - 0.5%));
        mask: radial-gradient(transparent 0, transparent 60%, white 60%);
        opacity: 50%;

        animation-name: anima3;
        animation-duration: 20s;
        animation-timing-function: linear;
        animation-iteration-count: infinite;
    }

    @keyframes anima3 {
        0% {
            rotate: 0;
        }
        100% {
            rotate: 360deg;
        }
    }

</style>